













import commons from "@/common/store/modules/commons";
import { Vue, Component, Prop } from "vue-property-decorator";

import { mapState } from "vuex";
@Component({})
export default class TextLink extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  hasUnderline!: boolean;
  @Prop({ type: String, default: "a" }) tag!: string;
  @Prop({ type: Boolean, required: false, default: false }) bold!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) blank!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  unuseCustomizeColor!: boolean;

  get customizeColor() {
    return commons.OrgPageSpecific?.page_color;
  }
  get customizeColorClass() {
    return !this.unuseCustomizeColor
      ? `u-text-color--${this.customizeColor}`
      : "";
  }
  get isLinkTag() {
    return this.tag === "a";
  }
  emitClickEvent() {
    this.$emit("click-button");
  }
}
